import { IProductFilterDTO } from './product-filter-base.model';

import ProductFilterCheckbox from './product-filter-checkbox.model';
import ProductFilterMultiSelect from './product-filter-multi-select.model';
import ProductFilterPriceSlider from './product-filter-price-slider.model';
import ProductFilterSingleSelect from './product-filter-single-select.model';
import ProductFilterSlider from './product-filter-slider.model';

export type IProductFilterType =
  | ProductFilterSingleSelect
  | ProductFilterSlider
  | ProductFilterPriceSlider
  | ProductFilterCheckbox
  | ProductFilterMultiSelect;

export default class ProductFilter {
  static create(data: IProductFilterDTO): IProductFilterType {
    if (data.facetDisplayType === 'DROPDOWN_SINGLE') {
      return ProductFilterSingleSelect.create(data);
    } else if (data.facetDisplayType === 'SLIDER') {
      return ProductFilterSlider.create(data);
    } else if (data.facetDisplayType === 'PRICE_SLIDER') {
      return ProductFilterPriceSlider.create(data);
    } else if (data.facetDisplayType === 'CHECKBOX') {
      return ProductFilterCheckbox.create(data);
    }

    return ProductFilterMultiSelect.create(data);
  }
}
